<script>
  import MarketingsTable from "../components/marketingsTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;

  const mountMarketingCount = async () => {
    const module = await import("App/MarketingActivities/count");
    const MarketingCount = module.default;

    if (el1) {
      el1.innerHTML = "";
      new MarketingCount({
        target: el1,
      });
    }
  };

  mountMarketingCount();
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <MarketingsTable />
    </div>
  </div>
</PageContainer>
